<template>
  <!-- 桌面端导航 -->
  <nav v-if="!isMobile" class="bg-gradient-to-r from-primary-500 to-primary-600 shadow-xl border-b border-white/20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <!-- Logo/Brand -->
        <div class="flex items-center">
          <div class="flex items-center space-x-2">
            <div class="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
              </svg>
            </div>
            <span class="text-xl font-bold text-white">Kanban Board</span>
          </div>
        </div>
        
        <!-- Navigation Links -->
        <div class="flex items-center space-x-1">
          <button 
            @click="goToHome"
            :class="['px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
            </svg>
            <span>当前看板</span>
          </button>

          <button 
            @click="goToMindMap"
            :class="['px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/mindmap' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
            </svg>
            <span>思维导图</span>
          </button>

          <button 
            @click="goToKnowledge"
            :class="['px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/knowledge' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
            <span>知识库</span>
          </button>

          <button
            @click="goToBoards"
            :class="['px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/boards' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <span>团队看板</span>
          </button>
          
          <button 
            @click="goToTeams"
            :class="['px-4 py-2 rounded-lg transition-all duration-200 flex items-center', $route.path === '/teams' ? 'bg-white/20 text-white font-semibold shadow-inner' : 'text-white/80 hover:text-white hover:bg-white/10']"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span>团队管理</span>
          </button>
        </div>
      </div>
    </div>
  </nav>

  <!-- 移动端导航：图标为主 + 文字在下方 -->
  <nav v-else class="mobile-nav bg-gradient-to-r from-primary-500 to-primary-600 shadow-xl border-b border-white/20">
    <div class="flex items-center justify-between w-full">
      <button 
        v-for="item in mobileNavItems" 
        :key="item.path"
        @click="item.action"
        :class="['mobile-nav-btn', $route.path === item.path ? 'active' : '']"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="mobile-nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.iconPath" />
        </svg>
        <span class="mobile-nav-label">{{ item.label }}</span>
      </button>
    </div>
  </nav>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useMobile } from '@/composables/useMobile'

const router = useRouter()
const { isMobile } = useMobile()

const goToHome = () => { router.push('/') }
const goToTeams = () => { router.push('/teams') }
const goToBoards = () => { router.push('/boards') }
const goToMindMap = () => { router.push('/mindmap') }
const goToKnowledge = () => { router.push('/knowledge') }

// 移动端导航配置
const mobileNavItems = [
  { path: '/', label: '看板', action: goToHome, iconPath: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z' },
  { path: '/mindmap', label: '导图', action: goToMindMap, iconPath: 'M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z' },
  { path: '/knowledge', label: '知识库', action: goToKnowledge, iconPath: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' },
  { path: '/boards', label: '团队板', action: goToBoards, iconPath: 'M4 6h16M4 12h16M4 18h16' },
  { path: '/teams', label: '团队', action: goToTeams, iconPath: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
]
</script>

<style scoped>
nav {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* 移动端导航样式 */
.mobile-nav {
  padding: 6px 0 4px;
}

.mobile-nav-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 2px;
  border-radius: 8px;
  transition: all 0.2s;
  color: rgba(255, 255, 255, 0.75);
  min-width: 0;
}

.mobile-nav-btn.active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-weight: 600;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.mobile-nav-icon {
  width: 22px;
  height: 22px;
  margin-bottom: 2px;
}

.mobile-nav-label {
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
}
</style>
